import { roundDecimals as m } from "@project-rouge/rg-core";
function u(r, o) {
  return r.map((n) => m(n, o));
}
export {
  u as RoundArray
};
//# sourceMappingURL=index4.js.map
